<!-- Overlay backdrop -->
<div
  class="mobile-menu__backdrop"
  (click)="onBackdropClick()"
  aria-hidden="true"
  puTestId="mobile-menu.backdrop"
></div>

<!-- Slide-in panel -->
<aside
  class="mobile-menu__panel"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'accessibility.navigation_menu' | translate"
  (click)="onPanelClick($event)"
  puTestId="mobile-menu.panel"
>
  <!-- Header with close button -->
  <div class="mobile-menu__header">
    <button
      class="mobile-menu__close"
      (click)="closeMenu.emit()"
      [attr.aria-label]="'accessibility.close_menu' | translate"
      puTestId="mobile-menu.close"
    >
      <rt-icon name="close" />
    </button>
  </div>

  <!-- Navigation section -->
  <nav class="mobile-menu__section">
    <h3 class="mobile-menu__section-title">
      {{ 'mobile_menu.navigation' | translate }}
    </h3>
    <ul class="mobile-menu__nav-list">
      @for (item of mainNavItems(); track item) {
        <li>
          <button
            class="mobile-menu__nav-item"
            [class.mobile-menu__nav-item--active]="activeMainTab() === item"
            (click)="onMainTabClick(item)"
            puTestId="mobile-menu.nav-item"
            [testData]="{ tab: item }"
          >
            {{ getMainNavLabel(item) }}
            @if (activeMainTab() === item) {
              <span class="mobile-menu__nav-indicator"></span>
            }
          </button>
        </li>
      }
    </ul>
  </nav>

  <!-- Product filters section -->
  <div class="mobile-menu__section">
    <h3 class="mobile-menu__section-title">
      {{ 'mobile_menu.filter_by_product' | translate }}
    </h3>
    <div class="mobile-menu__chips">
      @for (tab of productTabs; track tab) {
        <button
          class="mobile-menu__chip"
          [class.mobile-menu__chip--active]="activeProductTab() === tab"
          (click)="onProductTabClick(tab)"
          puTestId="mobile-menu.product-chip"
          [testData]="{ product: tab }"
        >
          {{ getProductTabLabel(tab) }}
        </button>
      }
    </div>
  </div>

  <!-- Settings section -->
  <div class="mobile-menu__section">
    <h3 class="mobile-menu__section-title">
      {{ 'mobile_menu.settings' | translate }}
    </h3>

    <!-- Language selector -->
    <div class="mobile-menu__setting">
      <label class="mobile-menu__setting-label" for="mobile-language-select">
        {{ 'mobile_menu.language' | translate }}
      </label>
      <select
        id="mobile-language-select"
        class="mobile-menu__select"
        [value]="currentLocale()"
        (change)="onLocaleChange($event)"
        puTestId="mobile-menu.language-select"
      >
        @for (locale of availableLocales(); track locale) {
          <option [value]="locale" [attr.selected]="currentLocale() === locale ? '' : null">
            {{ getLanguageLabel(locale) }}
          </option>
        }
      </select>
    </div>

    <!-- Theme toggle -->
    <div class="mobile-menu__setting">
      <span class="mobile-menu__setting-label">{{ 'mobile_menu.theme' | translate }}</span>
      <button
        class="mobile-menu__theme-toggle"
        (click)="onThemeToggle()"
        puTestId="mobile-menu.theme-toggle"
      >
        <rt-icon [name]="isDarkMode() ? 'dark' : 'light'" />
        <span>{{
          isDarkMode() ? ('mobile_menu.dark' | translate) : ('mobile_menu.light' | translate)
        }}</span>
      </button>
    </div>
  </div>

  <!-- Feedback link -->
  <div class="mobile-menu__footer">
    <rt-button variant="outline" size="medium" class="mobile-menu__feedback">
      {{ 'header.give_feedback' | translate }}
    </rt-button>
  </div>
</aside>
